import { SelectBox } from 'devextreme-react/select-box';
import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { Field, Panel } from '../../../../layouts';
import { useGetSalesAssociates } from '../api/get-sales-associates';
import { EstimateContext } from '../context/EstimateContext';

export default function StoreInformationPanel(props: { editableSalesAssocName?: boolean }) {

	const { order, modifyOrder } = useContext(EstimateContext);
	const store = useGetCompany(order.details.dealerID);
	const proxyStore = useGetCompany(order.details.proxyDealerCompanyID);
	const salesAssociates = useGetSalesAssociates(order.details.dealerID, !!props.editableSalesAssocName);

	return (
		<>
			<Panel
				header={'Store Information'}
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} visible={!!store.data?.PA_Zip}>{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
				<Field label={'Fax'} >{store.data?.fax}</Field>
				{
					order.details.proxyDealerCompanyID &&
					<Field label={'Proxy Store'} >{proxyStore.data?.companyCode + ' - ' + proxyStore.data?.companyName}</Field>
				}
				{
					store.data?.IME &&
					<Field label={'IME Status'} >{order.details.imeStatus}</Field>
				}
				{
					!props.editableSalesAssocName ?
						<>
							<Field label={'Sales Associate Number'} >{order.details.salesAssocNbr}</Field>
							<Field label={'Sales Associate Name'} >{order.details.salesAssocName}</Field>
						</>
						:
						<>
							<Field label={'Sales Associate Number'} >
								<SelectBox elementAttr={{ 'data-testid': 'dd-sales-assoc-number' }}
									dataSource={salesAssociates?.data.filter(x => x.employeeNumber && (!x.inactive || x.employeeNumber === order.details.salesAssocNbr))}
									valueExpr={'employeeNumber'}
									displayExpr={'employeeNumber'}
									showClearButton={true}
									value={order.details.salesAssocNbr}
									onValueChanged={(e) => {
										const salesAssocName = e.value ?
											salesAssociates?.data.find(x => x.employeeNumber === e.value)?.fullName : order.details.salesAssocName;
										modifyOrder({ ...order.details, salesAssocNbr: e.value, salesAssocName: salesAssocName });
									}}
								>
								</SelectBox>
							</Field>
							<Field label={'Sales Associate Name'} >
								<SelectBox elementAttr={{ 'data-testid': 'dd-sales-assoc-name' }}
									dataSource={salesAssociates?.data.filter(x => (!x.inactive || x.fullName === order.details.salesAssocName))}
									valueExpr={'fullName'}
									displayExpr={'fullName'}
									showClearButton={true}
									value={order.details.salesAssocName}
									onValueChanged={(e) => {
										const salesAssocNbr = e.value ?
											salesAssociates?.data.find(x => x.fullName === e.value)?.employeeNumber : order.details.salesAssocNbr;
										modifyOrder({ ...order.details, salesAssocName: e.value, salesAssocNbr: salesAssocNbr });
									}}
								>
								</SelectBox>
							</Field>
						</>
				}
			</Panel>
		</>
	);
}
